// Footer.jsx (v3 — modern, cleaner, less “agency pitch”, more trust + utility)
import React from "react";
import "./Footer.css";
import { useLocalContext } from "../../context/LocalContext";

const Footer = () => {
  const { webinfo = {} } = useLocalContext();
  const year = new Date().getFullYear();

  const brandName = webinfo.name || "Your Brand";
  const email = webinfo.email || "hello@example.com";
  const phone = webinfo.phone || "+91 80000 00000";
  const phonecall = webinfo.phonecall || "+918000000000";
  const address = webinfo.address || "Remote-first • Serving clients worldwide";
  const hours = webinfo.hours || "Mon–Sat · 10:00–19:00 IST";

  const handleSubscribe = (e) => {
    e.preventDefault();
    const val = e.target.elements.email?.value?.trim();
    if (!val) return;
    window.location.href = `mailto:${email}?subject=Updates%20request&body=Please%20add%20${encodeURIComponent(
      val
    )}%20to%20updates.`;
  };

  return (
    <footer className="ft3" aria-label={`${brandName} footer`}>
      <div className="ft3-wrap">
        {/* Top */}
        <div className="ft3-top">
          {/* Brand */}
          <section className="ft3-brand" aria-label="Footer brand">
            <a className="ft3-logo" href="/" aria-label={`${brandName} home`}>
              {/* <span className="ft3-mark" aria-hidden="true" />
              <span className="ft3-name">{brandName}</span> */}
              <img src={webinfo.logowhite} alt="" />
            </a>

            <p className="ft3-desc">
              Calm, practical help for building and improving websites — from design polish to
              performance, SEO, and automation.
            </p>

            <div className="ft3-highlights" aria-label="Highlights">
              <span className="tag">Fast communication</span>
              <span className="tag">Clear scope</span>
              <span className="tag">Quality-first builds</span>
              <span className="tag">NDA-friendly</span>
            </div>

            <form className="ft3-news" onSubmit={handleSubscribe} aria-label="Get updates">
              <label htmlFor="ft3-email" className="sr-only">
                Email address
              </label>
              <input
                id="ft3-email"
                name="email"
                type="email"
                required
                placeholder="you@company.com"
                autoComplete="email"
              />
              <button type="submit" className="ft3-btn">
                Get updates
              </button>
            </form>

            <p className="ft3-note">
              Occasional updates only — checklists, small wins, and new service notes.
            </p>
          </section>

          {/* Links */}
          <nav className="ft3-col" aria-labelledby="ft3-services">
            <h4 id="ft3-services">Services</h4>
            <ul>
              <li><a href="/services">Overview</a></li>
              <li><a href="/services/websites-experiences">Website builds</a></li>
              <li><a href="/services/analytics-optimization">SEO & performance</a></li>
              <li><a href="/services/automation-systems">Automation & systems</a></li>
              <li><a href="/services/launch-funnels">Funnels & landing pages</a></li>
              <li><a href="/process">How we work</a></li>
            </ul>
          </nav>

          <nav className="ft3-col" aria-labelledby="ft3-company">
            <h4 id="ft3-company">Company</h4>
            <ul>
              <li><a href="/about">About</a></li>
              <li><a href="/our-strategies">Notes</a></li>
              <li><a href="/contact">Contact</a></li>
              <li><a href="/services">Pricing approach</a></li>
              <li><a href="/process">Delivery process</a></li>
            </ul>
          </nav>

          {/* Contact */}
          <section className="ft3-contact" aria-labelledby="ft3-contact">
            <h4 id="ft3-contact">Contact</h4>

            <div className="ft3-card">
              <div className="row">
                <span className="k">Email</span>
                <a className="v" href={`mailto:${email}`}>{email}</a>
              </div>
              <div className="row">
                <span className="k">Phone</span>
                <a className="v" href={`tel:${phonecall}`}>{phone}</a>
              </div>
              <div className="row">
                <span className="k">Hours</span>
                <span className="v">{hours}</span>
              </div>
              <div className="row">
                <span className="k">Address</span>
                <span className="v">{address}</span>
              </div>

              <div className="social" aria-label="Social links">
                <a
                  href={webinfo.linkedin || "#"}
                  target="_blank"
                  rel="noreferrer"
                  aria-label="LinkedIn"
                >
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path
                      fill="currentColor"
                      d="M4.98 3.5A2.5 2.5 0 1 1 2.5 6a2.5 2.5 0 0 1 2.48-2.5zM3 8h4v13H3zM9 8h3.8v1.9h.05c.53-1 1.83-2.05 3.77-2.05 4.03 0 4.78 2.65 4.78 6.08V21H17v-5.6c0-1.33-.02-3.05-1.86-3.05-1.86 0-2.15 1.45-2.15 2.95V21H9z"
                    />
                  </svg>
                </a>
                <a
                  href={webinfo.twitter || "#"}
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Twitter / X"
                >
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path
                      fill="currentColor"
                      d="M18.244 2H21l-6.52 7.455L22 22h-6.24l-4.88-6.4L5.2 22H2l7.08-8.08L2 2h6.32l4.48 5.92L18.244 2Zm-1.1 18h1.8L7.02 4H5.18l11.964 16Z"
                    />
                  </svg>
                </a>
                <a
                  href={webinfo.instagram || "#"}
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Instagram"
                >
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path
                      fill="currentColor"
                      d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5Zm0 2a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H7Zm5 3.5a5.5 5.5 0 1 1 0 11.001A5.5 5.5 0 0 1 12 7.5Zm0 2a3.5 3.5 0 1 0 0 7.001 3.5 3.5 0 0 0 0-7.001Zm5.75-2.25a1 1 0 1 1 0 2.001 1 1 0 0 1 0-2.001Z"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </section>
        </div>

        {/* Bottom */}
        <div className="ft3-bottom">
          <p>© {year} {brandName}. All rights reserved.</p>

          <nav className="ft3-legal" aria-label="Legal">
            <a href="/terms-and-condition">Terms</a>
            <a href="/privacy-policy">Privacy</a>
            <a href="/disclaimer">Disclaimer</a>
          </nav>
        </div>

        <div className="ft3-fine" role="note">
          Content is for general informational purposes. For project-specific recommendations, contact the team.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
